import React from "react"
import { Link as GatsbyLink } from "gatsby"
import { Box, Link as ThemeLink, Flex, Container } from "theme-ui"
import footerLinks from "../constants/footerLinks"

export default (props) => (
  <Box
    as="footer"
    sx={{
      py: 5,
      color: "background",
      bg: "text",
      "& a": {
        color: "inherit",
      },
    }}
  >
    <Container>
      <Flex sx={{ flexDirection: "row", justifyContent: "space-between" }}>
        <Box>
          Created by{" "}
          <ThemeLink
            href="https://swizec.com"
            variant="nav"
            style={{ textDecoration: "underline" }}
          >
            Swizec
          </ThemeLink>{" "}
          with ❤️
        </Box>
        <Box
          sx={{
            a: {
              ml: [0, 2],
              display: "inline-block",
            },
            display: ["flex", "flex", "block"],
            flexDirection: "column",
          }}
          as="nav"
        >
          {footerLinks.map((link) => (
            <FooterLink key={link.Title} link={link} />
          ))}
        </Box>
      </Flex>
    </Container>
  </Box>
)

function FooterLink({ link }) {
  if (link.Link.startsWith("http")) {
    return (
      <ThemeLink href={link.Link} variant="nav">
        {link.Title}
      </ThemeLink>
    )
  } else {
    return (
      <ThemeLink as={GatsbyLink} key={link.Link} to={link.Link} variant="nav">
        {link.Title}
      </ThemeLink>
    )
  }
}
